export default class Address {
    constructor(data) {
        for (let key in data) {
            this[key] = data[key];
        }
    }

    getHtml() {
        return this.formattedAddress.replace(/[\n]/, '<br>');
    }
}
